// React Imports

const Logo = () => {
  return <img src='/images/logos/tankomar_pr.png' alt='Tankomar LTD' height={40} width={40}  />
}

export default Logo
